import { ApiState } from '../../utils/requestAction';
import requestReducer from '../requestReducer';
import DeliveryLocation from '../../models/DeliveryLocation';


export interface DeliveryLocationDetailState extends ApiState {
  deliveryLocation?: DeliveryLocation
}

export default requestReducer<DeliveryLocationDetailState>('DELIVERY_LOCATION_DETAIL')
